import StoresWorker from '../webworkers/get-stores.worker'
import { useQuery } from '@tanstack/react-query'
import { useGetAllStoresFromGatsby } from './useGetAllStoresFromGatsby'

const fetchStores = async ({
  stores,
  latitude,
  longitude,
  departments,
  services,
  storeType,
}) => {
  const worker = typeof window === 'object' && new StoresWorker()

  const response = await worker
    .getStores(stores, latitude, longitude, departments, services, storeType)
    .catch(e => {
      console.log(e?.message, 'WEB WORKER ERROR')
      throw e
    })

  return response
}

export const useGetStoresFromWebWorker = ({ latitude, longitude, filters }) => {
  const { departments, services, storeType } = filters || {}

  const stores = useGetAllStoresFromGatsby()

  const query = useQuery(
    [
      'storesListSW',
      stores,
      latitude,
      longitude,
      departments,
      services,
      storeType,
    ],
    () =>
      fetchStores({
        stores,
        latitude,
        longitude,
        departments,
        services,
        storeType,
      }),
    {
      enabled: stores?.length > 0 && !!latitude && !!longitude,
    }
  )

  return {
    ...query,
    isLoading: query.isLoading && query.fetchStatus !== 'idle',
    isLoadingOnly: query.isLoading,
  }
}
